import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PanelCard } from './ui/PanelCard';
const highlights = ['Web, carta y gestión incluidas', 'Pago único, sin cuotas mensuales', 'Reembolso íntegro antes de iniciar los trabajos'];
export function PageCTA() {
  return <section className="border-t border-white/10 bg-[#0a0a0a] py-20 sm:py-28" aria-labelledby="page-cta-title" data-id="element-91" data-mp="z49vgpz5a54y">
      <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-92" data-mp="1qu4q925run10">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-4xl" data-id="element-93" data-mp="1qvfqis00dcnd">
          <PanelCard title="Demos a tu presencia digital una dirección concreta." meta="Empezar" titleId="page-cta-title" data-id="element-94" data-mp="sbd4lyal546c">
            <div className="grid sm:grid-cols-[1.1fr_0.9fr]" data-id="element-95" data-mp="o7ydocl3z3e4">
              <div className="px-6 py-8 sm:px-9 sm:py-10" data-id="element-96" data-mp="122hguq8vmaxh">
                <p className="text-[15px] leading-relaxed text-neutral-600" data-id="element-97" data-mp="xapoca65tv4p">
                  Una oferta completa, un precio definido y una ruta de trabajo
                  fácil de seguir.
                </p>
                <ul className="mt-7 space-y-3 border-t border-black/15 pt-6" data-id="element-98" data-mp="171284065hk9s">
                  {highlights.map(item => <li key={item} className="flex gap-3 text-[13px] leading-relaxed text-neutral-700" data-id="element-99" data-mp="1kz0lp3cndco8">
                      <CheckIcon size={15} className="mt-0.5 shrink-0 text-black" aria-hidden="true" data-id="element-100" data-mp="3mr58y1j7blsm" />
                      {item}
                    </li>)}
                </ul>
              </div>
              <div className="flex flex-col justify-between border-t-2 border-black/15 px-6 py-8 sm:border-l-2 sm:border-t-0 sm:px-9 sm:py-10" data-id="element-101" data-mp="1qnqrwzeyl0df">
                <div data-id="element-102" data-mp="1vmbtb25y5q3g">
                  <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-neutral-500" data-id="element-103" data-mp="1zp8gl66fmadq">
                    Pago único
                  </p>
                  <p className="mt-4 text-5xl font-medium tracking-[-0.06em] text-black" data-id="element-104" data-mp="24ni9fa4ooyw6">
                    350 €
                  </p>
                  <p className="mt-2 text-[12px] font-medium uppercase tracking-[0.18em] text-neutral-500" data-id="element-105" data-mp="29l1t4pk5i3vi">
                    EUR
                  </p>
                </div>
                <Link to="/checkout" className="group mt-8 flex items-center justify-center gap-2 bg-black px-5 py-4 text-sm font-semibold text-white transition-colors hover:bg-neutral-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-106" data-mp="2jcegp4yx27vq">
                  Solicitar mi proyecto
                  <ArrowRightIcon size={16} className="transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-107" data-mp="btk6w6094v65" />
                </Link>
              </div>
            </div>
          </PanelCard>
        </motion.div>
      </div>
    </section>;
}